export default {
  path: '/success',
  meta: {
    title: '支付结果',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/success`),
}



// WEBPACK FOOTER //
// ./src/views/Success/router.js